import { ReactNode } from 'react';
export default function DataPanel({title,actions,children}:{title:string;actions?:ReactNode;children:ReactNode}){
    return <section className="card table-card-custom spark-data-panel"><div className="table-header-control"><h2>{title}</h2><div className="spark-panel-actions">{actions}</div></div><div className="spark-panel-content">{children}</div></section>;
}
